import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";

// Define a service using a base URL and expected endpoints
export const SurveyApi = createApi({
  reducerPath: "surveyApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getSurveys: builder.query({
      query: () => ({
        url: `/survey/all`,
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    }),
    getSurvey: builder.query({
      query: (id) => ({
        url: `/survey/${id}`,
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    }),
    getSurveyResultBySurveyAndParentId: builder.query({
      query: ({ surveyId, parentId }) => ({
        url: `/survey/result/${surveyId}/${parentId}`,
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    }),
    addSurvey: builder.query({
      query: ({ survey }) => ({
        url: `/survey/create`,
        method: "POST",
        // TO DO Change body
        body: { survey }
      }),
      extraOptions: { service: "Utility" }
    }),
    addSurveyResult: builder.query({
      query: ({ surveyId, survey, parentId }) => ({
        url: `/survey/usersubmit/${surveyId}`,
        method: "POST",
        // TO DO here change body
        body: { surveyId, survey, parentId }
      }),
      extraOptions: { service: "Utility" }
    }),
    addAssessmentSurveyResult: builder.query({
      query: ({ surveyId, survey, parentId, ongoingId }) => ({
        url: `/survey/assessment/usersubmit/${surveyId}`,
        method: "POST",
        body: { surveyId, survey, parentId, ongoingId }
      }),
      extraOptions: { service: "Utility" }
    }),
    getSurveyResultById: builder.query({
      query: ({ surveyId }) => ({
        url: `/survey/result/${surveyId}`,
        method: "get"
      }),
      extraOptions: { service: "Utility" }
    }),
    getSurveyCountByIds: builder.query({
      query: ({ surveyId, parentId, parentType }) => ({
        url: `/survey/cumulative/${surveyId}/${parentId}/${parentType}`,
        method: "get"
      }),
      extraOptions: { service: "Utility" }
    }),
    getFeedbackBtnEnabledById: builder.query({
      query: ({ contentId, contentType }) => ({
        url: `/survey/lxp/enabled/${contentId}/${contentType}`,
        method: "get"
      }),
      extraOptions: { service: "Utility" }
    }),
    addFeedbackResult: builder.query({
      query: ({ surveyId, survey, parentType, parentId }) => ({
        url: `/survey/${parentType}/usersubmit/${surveyId}`,
        method: "POST",
        body: { surveyId, survey, parentId }
      }),
      extraOptions: { service: "Utility" }
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyAddSurveyResultQuery,
  useLazyAddFeedbackResultQuery,
  useLazyAddAssessmentSurveyResultQuery,
  useGetSurveyQuery,
  useLazyAddSurveyQuery,
  useLazyGetSurveyQuery,
  useLazyGetSurveyResultByIdQuery,
  useGetSurveysQuery,
  useGetSurveyResultByIdQuery,
  useGetSurveyResultBySurveyAndParentIdQuery,
  useLazyGetSurveyResultBySurveyAndParentIdQuery,
  useLazyGetSurveyCountByIdsQuery,
  useLazyGetFeedbackBtnEnabledByIdQuery
} = SurveyApi;
export default SurveyApi;
